/** Namespace `lab` — PLAT-2026-141 GĐ2 · ADR-041 D5: PHÒNG THỬ (L1) — fixture, lượt thử, danh sách phòng thử theo bộ. Bản gốc tiếng Việt. */
export const lab = {
  catalogServiceCount: "{count} dịch vụ",
  configureService: "Cấu hình dịch vụ",
  supportedApps: "Dùng cho:",
  supportedEnvironments: "Hỗ trợ:",
  serviceNoConnections: "Chưa có kết nối thử. Mở Cấu hình dịch vụ để thiết lập.",
  serviceNoConnectionsInEnvironment:
    "Chưa có kết nối thử ở môi trường đã chọn. Mở Cấu hình dịch vụ để thiết lập.",

  appEmpty:
    "Ứng dụng này chưa có kết nối để mở phòng thử. Vào Tích hợp để thiết lập kết nối phù hợp.",
  filterApp: "Chọn ứng dụng",
  labCount: "{count} kết nối thử",
  filters: "Bộ lọc phòng thử",
  filterCategory: "Loại dịch vụ",
  allCategories: "Tất cả loại dịch vụ",
  filterEnvironment: "Môi trường",
  allEnvironments: "Tất cả môi trường",
  searchLabs: "Tìm phòng thử",
  searchPlaceholder: "Tên kết nối hoặc nhà cung cấp…",
  appScopeHelp:
    "Lọc theo tích hợp app sử dụng được. Tài khoản và dữ liệu thử vẫn dùng riêng tại HQ.",
  resetFilters: "Xóa bộ lọc",
  legacyKind: "Liên kết này đang giới hạn một nhóm kết nối theo cách phân chia cũ.",
  clearKind: "Bỏ giới hạn này",
  retryLabs: "Thử tải lại",
  allServices: "Tất cả dịch vụ",
  resultCount: "{count} kết nối · {products} sản phẩm",
  noMatchingLabs: "Không có phòng thử khớp các bộ lọc đã chọn.",
  configureIntegration: "Cấu hình tích hợp",
  openNamedLab: "Mở phòng thử {name} — {connection} — {environment}",
  testStatusHelp:
    "Trạng thái bên cạnh kết nối là kết quả kiểm thử, không phải trạng thái bật/tắt của app.",

  fixtureExpired: "Đã hết hạn",
  // ── Trang chung ──
  indexTitle: "Phòng thử",
  indexIntro:
    "Chọn ứng dụng, tìm dịch vụ rồi mở kết nối cần thử. Tài khoản và dữ liệu thử của Bube được quản lý riêng tại HQ.",
  indexEmpty: "Chưa có bộ thông số nào có phòng thử.",
  openLab: "Mở phòng thử",
  loading: "Đang tải…",
  loadFailed: "Không tải được: {error}",
  noPermission: "Vai của bạn không xem được phòng thử (cần quyền « hq.lab.read »).",

  // ── Fixture ──
  fixturesTitle: "Dữ liệu thử",
  fixturesIntro:
    "Danh tính thử của Bube đóng vai khách (MST thử, tài khoản HĐĐT thử, TK ngân hàng thử). Không gắn với bộ thông số nào — ở phòng thử chọn dữ liệu thử và bộ riêng, nên dữ liệu thử live kiểm được cả khoá production của Bube. Ô bí mật không bao giờ quay lại trang.",
  fixturesEmpty: "Chưa có dữ liệu thử.",
  addFixture: "Thêm dữ liệu thử",
  colLabel: "Tên",
  colProduct: "Sản phẩm",
  colEnvironment: "Môi trường",
  colOwner: "Chủ",
  colStatus: "Trạng thái",
  colAllowlist: "Đích được phép",
  colSecrets: "Ô bí mật đã lưu",
  colLastUsed: "Dùng gần nhất",
  colActions: "Thao tác",
  never: "chưa dùng",
  env_sandbox: "Sandbox",
  env_live: "Production",
  owner_organization: "Bube",
  owner_team: "Nhóm {id}",
  owner_user: "Người {id}",
  status_active: "Đang dùng",
  status_disabled: "Đã tắt",
  status_expired: "Hết hạn",
  edit: "Sửa",
  disable: "Tắt",
  enable: "Bật",
  remove: "Xoá",
  removeConfirm: "Bấm lần nữa để xoá",
  viewRuns: "Lượt thử",
  readOnlyRole: "Vai của bạn chỉ xem được — sửa dữ liệu thử cần quyền « hq.lab.write ».",

  // ── Form ──
  formCreateTitle: "Dữ liệu thử mới",
  formEditTitle: "Sửa dữ liệu thử « {label} »",
  fieldProduct: "Sản phẩm",
  fieldEnvironment: "Môi trường nhà cung cấp",
  fieldLabel: "Tên dữ liệu thử",
  fieldLabelHint: "Thao tác GHI bằng dữ liệu thử live phải gõ lại đúng tên này.",
  fieldOwnerType: "Chủ",
  fieldOwnerId: "Định danh chủ (email người / mã nhóm)",
  fieldsTitle: "Ô tài khoản thử",
  fieldsFreeHint: "Sản phẩm này không khai ô tài khoản khách — mỗi dòng một ô dạng khoá=giá trị.",
  fieldsPublic: "Ô không bí mật",
  fieldsSecret: "Ô bí mật",
  secretSaved: "đã lưu {hint} — để trống = giữ",
  forgetSecret: "Xoá ô này",
  fieldTarget_taxCode: "MST được phép (allowlist)",
  fieldTarget_accountNumber: "Số TK / VA được phép (allowlist)",
  fieldTarget_companyXid: "Công ty Bank Hub được phép (company_xid)",
  fieldTargetHint:
    "Phân tách dấu phẩy. Giá trị đầu tiên là đích mặc định của lượt chạy. Dữ liệu thử live muốn GHI lên đích này phải khai.",
  fieldWritesPerDay: "Trần lượt GHI mỗi 24 giờ",
  fieldWritesPerDayHint: "Để trống = không giới hạn.",
  fieldExpiresAt: "Hết hạn lúc",
  fieldOperations: "Thao tác được phép",
  fieldOperationsHint:
    "Rào chỉ cho chạy thao tác có khả năng nằm trong danh sách. Để trống = CHỈ ĐỌC (mọi thao tác ghi bị chặn).",
  fieldAllowRawReads: "Cho phép API thô CHỈ ĐỌC",
  fieldAllowRawReadsHint:
    "API của nhà cung cấp không ứng với khả năng chuẩn nào (danh sách, mẫu số, lịch sử…). API thô GHI luôn bị chặn.",
  save: "Lưu",
  saving: "Đang lưu…",
  cancel: "Huỷ",
  saveFailed: "Không lưu được: {error}",

  // ── Lượt thử ──
  runsTitle: "Lịch sử thử",
  runsIntro:
    "Mỗi lượt chạy phòng thử (kể cả lượt bị rào chặn) và mỗi lần « Chạy thử » một bộ là một lượt thử — chứng nhận của bộ đó.",
  runsEmpty: "Chưa có lượt thử nào.",
  runsFilterFixture: "Dữ liệu thử",
  runsFilterAll: "Tất cả",
  colTime: "Lúc",
  colFixture: "Dữ liệu thử",
  colSet: "Kết nối",
  colOperation: "Thao tác",
  colOutcome: "Kết quả",
  colReason: "Chi tiết",
  colActor: "Người chạy",
  outcome_passed: "Đạt",
  outcome_failed: "Hỏng",
  outcome_blocked: "Bị chặn",
  confirmedIdentifier: "đã gõ lại tên",
  writeRun: "ghi",
  setTest: "Chạy thử bộ",
  noFixture: "—",

  // ── Lý do rào chặn (`LAB_GUARD_REASONS`) ──
  reason_LAB_OPERATION_EFFECT_UNKNOWN: "Thao tác không khai đọc / ghi — không chạy.",
  reason_LAB_FIXTURE_REQUIRED:
    "Thao tác ghi, thao tác thô hoặc thao tác cần tài khoản thử phải chọn dữ liệu thử.",
  reason_LAB_OPERATION_NOT_ALLOWED:
    "Thao tác không nằm trong danh sách được phép của dữ liệu thử (danh sách trống = chỉ đọc; API thô ghi luôn bị chặn).",
  reason_LAB_RAW_READ_NOT_ALLOWED:
    "API thô chỉ đọc cần dữ liệu thử bật « Cho phép API thô chỉ đọc ».",
  reason_LAB_FIXTURE_INACTIVE: "Dữ liệu thử đã tắt hoặc hết hạn.",
  reason_LAB_PRODUCT_MISMATCH: "Dữ liệu thử thuộc sản phẩm khác bộ đang thử.",
  reason_LAB_ENVIRONMENT_MISMATCH: "Môi trường của dữ liệu thử khác môi trường của bộ.",
  reason_LAB_CONFIRM_IDENTIFIER_REQUIRED:
    "Thao tác ghi bằng dữ liệu thử live cần gõ lại đúng tên dữ liệu thử.",
  reason_LAB_TAX_CODE_NOT_ALLOWED: "MST của lượt chạy không nằm trong allowlist của dữ liệu thử.",
  reason_LAB_TARGET_NOT_ALLOWED:
    "Đích của lượt chạy (số TK / công ty) không nằm trong allowlist của dữ liệu thử.",
  reason_LAB_LIMIT_REACHED: "Đã chạm trần lượt ghi 24 giờ của dữ liệu thử.",

  // ── Phòng thử HĐĐT ──
  pickFixture: "Dữ liệu thử",
  pickFixtureNone: "Không dùng dữ liệu thử (chỉ chạy được thao tác ĐỌC không cần tài khoản thử)",
  pickFixtureHint:
    "Chỉ hiện dữ liệu thử cùng sản phẩm + môi trường với bộ. Thao tác ghi / thô / cần tài khoản thử bắt buộc chọn dữ liệu thử. Ô gõ trên trang thắng ô của dữ liệu thử.",
  pickFixtureEmpty: "Chưa có dữ liệu thử cùng sản phẩm + môi trường.",
  manageFixtures: "Quản lý dữ liệu thử",
  confirmIdentifier: "Gõ lại tên dữ liệu thử để ghi",
} as const;
